module.exports = __webpack_public_path__ + "img/company_icon3.e67da9c1.png";